import { supabase } from '../supabaseClient';
import { format } from 'date-fns';

// Profile Classes
export const cancelClassProfile = async (classProfileId) => {
  const { data: record } = await supabase
    .from('classprofile')
    .select('calendar_class, waiting_list')
    .eq('id', classProfileId)
    .single();

  const { error } = await supabase
    .from('classprofile')
    .update({ canceled_at: new Date().toISOString() })
    .eq('id', classProfileId);

  if (error) {
    alert('No se pudo quitar el usuario: ' + error.message);
    return null;
  }

  return record ?? null;
};

export const fetchClassProfiles = async (calendarClassId, includeCanceled) => {
  let query = supabase
    .from('classprofile')
    .select('id, user_id, waiting_list, canceled_at, profiles: profiles(id, full_name, email)')
    .eq('calendar_class', calendarClassId);

  if (!includeCanceled) {
    query = query.is('canceled_at', null);
  }

  const { data, error } = await query.order('id', { ascending: true });

  if (error) {
    alert(`Error loading classes: ${error.message}`);
    throw error;
  }
  return data;
};

export const fetchCalendarClassWithProfiles = async (selectedClassId = null, dateStr = null) => {
  let query = supabase
    .from('calendarclass_with_counts').select(`
      calendarclass_id,
      class_id,
      date,
      starttime,
      endtime,
      color,
      comment,
      title,
      maxattendees,
      confirmed_count
    `);
  if (selectedClassId) {
    query = query.eq('class_id', selectedClassId);
  }
  if (dateStr) {
    query = query.eq('date', dateStr);
  }
  const { data, error } = await query.order('starttime', { ascending: true });
  if (error) {
    alert(`Error fetchCalendarClassWithProfiles: ${error.message}`);
    throw error;
  }
  return data;
};

export const addClassProfile = async (userId, calendarclassId, isWaitlist, bonus) => {
  const { error } = await supabase.from('classprofile').upsert({
    user_id: userId,
    calendar_class: calendarclassId,
    waiting_list: isWaitlist,
    bonus: bonus,
  });

  if (error) {
    alert(`Error adding class profile: ${error.message}`);
    throw error;
  }
  return true;
};

export const fetchClassProfileCalendar = async (userId, includeCanceled) => {
  let query = supabase
    .from('class_profiles_calendar')
    .select('*')
    .eq('user_id', userId)
    .order('date', { ascending: false });

  if (!includeCanceled) {
    query = query.is('canceled_at', null);
  }

  const { data, error } = await query.order('id', { ascending: true });
  if (error) {
    alert(`Error fetchClassProfileCalendar: ${error.message}`);
    throw error;
  }
  return { data };
};

export const fetchProfileBonus = async (userId) => {
  const { data, error } = await supabase
    .from('profile_bonus')
    .eq('user_id', userId)
    .select('*');
  if (error) {
    alert(`Error fetchProfileBonus: ${error.message}`);
    throw error;
  }
  return data;
};